import React from "react"
import styles from "../../styles/global.module.scss"
import moment from "moment"

const Categories = props => {
  const { categories } = props
  if (categories) {
    return (
      <div className={`${styles.jobLine} ${styles.flexWrapper}`}>
        <div className={styles.jobLineLeft}>
          <span>Categories:</span>
        </div>
        <div className={styles.jobLineRight}>
          <ul>
            {categories.map((category, i) => {
              return <li>{category}</li>
            })}
          </ul>
        </div>
      </div>
    )
  } else {
    return false
  }
}

export default function JobInformation(props) {
  const { job } = props
  // Check if dates exist and format w/ moment
  let { start_date, end_date } = job
  let show_dates = true
  if (!start_date && !end_date) {
    show_dates = false
  } else {
    if (start_date) {
      start_date = moment(start_date).format("MMM Do, YYYY")
    } else {
      start_date = "Starting Soon"
    }
    if (end_date) {
      end_date = moment(end_date).format("MMM Do, YYYY")
    } else {
      end_date = "In Progress"
    }
  }
  return (
    <div id={styles.jobInformation}>
      <div className={`${styles.jobLine} ${styles.flexWrapper}`}>
        <div className={styles.jobLineLeft}>
          <span>Location:</span>
        </div>
        <div className={styles.jobLineRight}>
          <span>{job.location}</span>
        </div>
      </div>
      <div className={`${styles.jobLine} ${styles.flexWrapper}`}>
        <div className={styles.jobLineLeft}>
          <span>Description:</span>
        </div>
        <div className={styles.jobLineRight}>
          <span>{job.subtitle}</span>
        </div>
      </div>
      {show_dates ? (
        <>
          <div className={`${styles.jobLine} ${styles.flexWrapper}`}>
            <div className={styles.jobLineLeft}>
              <span>Start Date:</span>
            </div>
            <div className={styles.jobLineRight}>
              <span>{start_date}</span>
            </div>
          </div>
          <div className={`${styles.jobLine} ${styles.flexWrapper}`}>
            <div className={styles.jobLineLeft}>
              <span>End Date:</span>
            </div>
            <div className={styles.jobLineRight}>
              <span>{end_date}</span>
            </div>
          </div>
        </>
      ) : null}
      <Categories categories={job.categories} />
    </div>
  )
}
